module.exports = __webpack_public_path__ + "static/media/CrazyCrystalCollectors.110ffbc7.png";